import { GetTimezoneOffset, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class ExportService {
  DoExportTaxWhtCertificatePndReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      pndId: input.pndId,
      pndType: input.pndType,
      isListItem: input.isListItem,
      isShowRefDocument: input.isShowRefDocument,
      receiveEmailList: input.receiveEmailList,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
    };
    return service.peakTaxAPI.post("/api/Report/ExportTaxPndReport", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoExportTaxTransactionPP30Report(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      pp30Id: input.pp30Id,
      language: i18n.locale,
      financeType: input.financeType,
      isShowRefDocument: input.isShowRefDocument,
      isShowVatType: input.isShowVatType,
      receiveEmailList: input.receiveEmailList,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
    };
    return service.peakTaxAPI
      .post("/api/Report/ExportTaxPP30TransactionReport", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoExportTaxWhtCertificateReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      pndType: input.pndType,
      isListItem: input.isListItem,
      isShowRefDocument: input.isShowRefDocument,
      isSendEmail: input.isSendEmail,
      receiveEmailList: input.receiveEmailList,
      fromEmail: input.fromEmail,
      reportHeaderType: input.pickedReportHeaderType,
      tableStatus: input.tableStatus,
    };
    return service.peakTaxAPI
      .post("/api/Report/ExportTaxWhtCertificateReport", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoExportTaxTransactionReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      financeType: input.financeType,
      isShowVatType: input.isShowVatType,
      isShowRefDocument: input.isShowRefDocument,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableSortType: input.tableSortType,
      transactionTableSortColumnType: input.transactionTableSortColumnType,
      reportHeaderType: input.pickedReportHeaderType,
      tableStatus: input.tableStatus,
    };
    return service.peakTaxAPI.post("/api/Report/ExportTaxTransactionReport", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoExportContact(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      reportCriteriaModel: input.reportCriteria,
      contactGroupId: input.contactGroupId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      language: i18n.locale,
      isShowArchivedContact: input.isShowArchivedContact,
      contactTableViewStatusType: input.contactTableViewStatusType,
    };
    return service.peakExportAPI
      .post("/api/EmailReport/ExportContactTemplate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ExportService();
